(function () {
    var sections = document.querySelectorAll('.story-section');
    if (!sections.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        // No IO support: just show everything, no progressive reveal.
        for (var i = 0; i < sections.length; i++) {
            sections[i].classList.add('is-in-view');
        }
        return;
    }

    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-in-view');
                io.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    for (var j = 0; j < sections.length; j++) {
        io.observe(sections[j]);
    }
}());
